var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { createStyles } from 'antd-style';
import "../styles/fonts.css";
export default createStyles(function (_ref, props) {
  var css = _ref.css;
  var fontFamily = props.fontFamily,
    _props$size = props.size,
    size = _props$size === void 0 ? 'normal' : _props$size,
    level = props.level;
  var lineHeight = 0;
  var fontSize = 0;
  switch (level) {
    case 1:
      fontSize = 56;
      lineHeight = 64;
      break;
    case 2:
      fontSize = 48;
      lineHeight = 56;
      break;
    case 3:
      fontSize = 40;
      lineHeight = 48;
      break;
    case 4:
      fontSize = 32;
      lineHeight = 40;
      break;
    case 5:
      fontSize = 24;
      lineHeight = 32;
      break;
    case 6:
      fontSize = 20;
      lineHeight = 28;
      break;
    case 7:
      fontSize = 16;
      lineHeight = 24;
      break;
    default:
      break;
  }
  return {
    AelfDesignTitle: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        font-weight: ", " !important;\n        font-size: ", "px !important;\n        line-height: ", "px !important;\n        text-rendering: optimizeLegibility;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n      "])), fontFamily, fontSize, lineHeight),
    AelfDesignText: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        font-weight: ", " !important;\n        display: inline-block;\n        font-size: ", ";\n        line-height: ", ";\n        text-rendering: optimizeLegibility;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n      "])), fontFamily, size === 'normal' ? '14px' : size === 'small' ? '12px' : '10px', size === 'normal' ? '22px' : size === 'small' ? '20px' : '18px')
  };
});